import { useState, useEffect } from 'react';
import API from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { S } from '../../components/pageStyles';
import { Loader } from '../../components/ui';
import { LuFileText, LuGift, LuLightbulb, LuLock, LuLockOpen, LuPackage, LuPencil, LuPlus, LuStore, LuTrash2, LuWallet } from 'react-icons/lu';

import { fmtF } from '../../theme';
export default function KitsProprietaire() {
  const [etablissements, setEtablissements] = useState([]);
  const [etabSelectionne, setEtabSelectionne] = useState(null);
  const [kits, setKits] = useState([]);
  const [produits, setProduits] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [vue, setVue] = useState('liste');
  const [kitSelectionne, setKitSelectionne] = useState(null);
  const [message, setMessage] = useState('');
  const [recherche, setRecherche] = useState('');

  const [form, setForm] = useState({
    nom: '', description: '', prix_kit: ''
  });
  const [composants, setComposants] = useState([]);
  const [produitAjoute, setProduitAjoute] = useState('');
  const [qteAjoutee, setQteAjoutee] = useState(1);

  const chargerDonnees = async () => {
    try {
      const etabRes = await API.get('/etablissements');
      const etabs = etabRes.data.etablissements || [];
      setEtablissements(etabs);
      if (etabs.length > 0) {
        setEtabSelectionne(etabs[0].id);
        await chargerKits(etabs[0].id);
        await chargerProduits(etabs[0].id);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setChargement(false);
    }
  };

  const chargerKits = async (etabId) => {
    try {
      const res = await API.get('/kits?etablissement_id=' + etabId);
      setKits(res.data.kits || []);
    } catch (err) {
      console.error(err);
    }
  };

  const chargerProduits = async (etabId) => {
    try {
      const res = await API.get('/produits?etablissement_id=' + etabId);
      setProduits(res.data.produits || []);
    } catch (err) {
      console.error(err);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { chargerDonnees(); }, []);

  const handleSelectEtab = async (etabId) => {
    setEtabSelectionne(etabId);
    await chargerKits(etabId);
    await chargerProduits(etabId);
    setVue('liste');
    resetForm();
  };

  const resetForm = () => {
    setForm({ nom: '', description: '', prix_kit: '' });
    setComposants([]);
    setProduitAjoute('');
    setQteAjoutee(1);
    setKitSelectionne(null);
  };

  const ajouterComposant = () => {
    if (!produitAjoute) return;
    const produit = produits.find(p => p.id === parseInt(produitAjoute));
    if (!produit) return;
    const existe = composants.find(c => c.produit_id === parseInt(produitAjoute));
    if (existe) {
      setComposants(composants.map(c =>
        c.produit_id === parseInt(produitAjoute)
          ? { ...c, quantite: c.quantite + parseInt(qteAjoutee) }
          : c
      ));
    } else {
      setComposants([...composants, {
        produit_id: parseInt(produitAjoute),
        nom: produit.nom,
        prix: produit.prix,
        unite: produit.unite,
        quantite: parseInt(qteAjoutee)
      }]);
    }
    setProduitAjoute('');
    setQteAjoutee(1);
  };

  const retirerComposant = (produitId) => {
    setComposants(composants.filter(c => c.produit_id !== produitId));
  };

  const prixCalcule = composants.reduce((t, c) =>
    t + parseFloat(c.prix) * c.quantite, 0
  );

  const handleModifier = (kit) => {
    setKitSelectionne(kit);
    setForm({
      nom: kit.nom || '',
      description: kit.description || '',
      prix_kit: kit.prix_kit || ''
    });
    setComposants((kit.produits || []).map(p => ({
      produit_id: p.id,
      nom: p.nom,
      prix: p.prix,
      unite: p.unite,
      quantite: p.qte_kit || 1
    })));
    setVue('formulaire');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (composants.length === 0) {
      setMessage('❌ Ajoutez au moins un produit au kit');
      return;
    }
    try {
      const data = {
        ...form,
        etablissement_id: etabSelectionne,
        produits: composants.map(c => ({
          produit_id: c.produit_id,
          quantite: c.quantite
        }))
      };

      if (kitSelectionne) {
        await API.put('/kits/' + kitSelectionne.id, data);
        setMessage('✅ Kit modifié avec succès !');
      } else {
        await API.post('/kits', data);
        setMessage('✅ Kit créé avec succès !');
      }
      chargerKits(etabSelectionne);
      setVue('liste');
      resetForm();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

 const handleToggle = async (kit) => {
  if (!window.confirm(kit.actif ? 'Désactiver ce kit ?' : 'Réactiver ce kit ?')) return;
  try {
    await API.patch('/kits/' + kit.id + '/toggle');
    setMessage(kit.actif ? '✅ Kit désactivé !' : '✅ Kit réactivé !');
    chargerKits(etabSelectionne);
    setTimeout(() => setMessage(''), 3000);
  } catch (err) {
    setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
  }
};

const handleSupprimer = async (kit) => {
  if (!window.confirm('Supprimer définitivement "' + kit.nom + '" ?')) return;
  try {
    await API.delete('/kits/' + kit.id);
    setMessage('✅ Kit supprimé !');
    chargerKits(etabSelectionne);
    setTimeout(() => setMessage(''), 3000);
  } catch (err) {
    setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
  }
};

  const kitsFiltres = kits.filter(k =>
    k.nom.toLowerCase().includes(recherche.toLowerCase())
  );

  const etabActuel = etablissements.find(e => e.id === etabSelectionne);

  if (chargement) return <Loader />;

  return (
    <AppLayout role="proprietaire">

      {/* CONTENU */}
      <div style={styles.contenu}>

        {message && (
          <div role="status" style={{
            ...styles.messageBox,
            background: message.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
            color: message.startsWith('✅') ? '#047857' : '#B91C1C'
          }}>{message.replace(/^(✅|❌|⚠️)\s*/, '')}</div>
        )}

        {/* HEADER */}
        <div style={styles.header}>
          <div>
            <h1 style={styles.headerTitre}>Mes Kits</h1>
            <p style={styles.headerSousTitre}>
              {etabActuel?.nom + ' • ' + kits.length + ' kit(s)'}
            </p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {vue !== 'liste' && (
              <button onClick={() => { setVue('liste'); resetForm(); }} style={styles.boutonRetour}>
                ← Retour
              </button>
            )}
            {vue === 'liste' && (
              <button onClick={() => { resetForm(); setVue('formulaire'); }} style={styles.boutonAjouter}>
                + Nouveau Kit
              </button>
            )}
          </div>
        </div>

        {/* SÉLECTEUR ÉTABLISSEMENT */}
        <div style={styles.etabSelector}>
          <div style={styles.etabSelectorTitre}>Établissement</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {etablissements.map((etab, i) => (
              <div key={i} onClick={() => handleSelectEtab(etab.id)} style={{
                padding: '10px 16px', borderRadius: 10, cursor: 'pointer',
                border: etabSelectionne === etab.id ? '2px solid #EA580C' : '2px solid #E2E8F0',
                background: etabSelectionne === etab.id ? '#FFF7ED' : 'white',
                fontWeight: 700, fontSize: 13, color: '#0F172A',
                display: 'flex', alignItems: 'center', gap: 6
              }}>
                <LuStore aria-hidden style={{ verticalAlign: '-0.125em' }} /> {etab.nom}
                {etabSelectionne === etab.id && <span style={{ color: '#EA580C' }}>✓</span>}
              </div>
            ))}
          </div>
        </div>

        {/* ── LISTE ── */}
        {vue === 'liste' && (
          <>
            <div style={styles.filtres}>
              <input
                type="text" placeholder="Rechercher un kit..."
                value={recherche} onChange={(e) => setRecherche(e.target.value)}
                style={styles.rechercheInput}
              />
              <span style={{ color: '#64748B', fontSize: 13 }}>{kitsFiltres.length + ' kit(s)'}</span>
            </div>

            {kitsFiltres.length === 0 ? (
              <div style={styles.vide}>
                <div style={{ fontSize: 60 }}><LuGift aria-hidden style={{ verticalAlign: '-0.125em' }} /></div>
                <p style={{ fontWeight: 700, fontSize: 16, marginTop: 12 }}>Aucun kit</p>
                <p style={{ color: '#94A3B8', fontSize: 13 }}>Créez des kits pour regrouper vos produits</p>
              </div>
            ) : (
              <div style={styles.kitsGrid}>
                {kitsFiltres.map((kit, i) => (
                  <div key={i} style={{
                    ...styles.kitCard,
                    opacity: kit.actif ? 1 : 0.6
                  }}>
                    <div style={styles.kitHeader}>
                      <div style={styles.kitIcon}><LuGift aria-hidden style={{ verticalAlign: '-0.125em' }} /></div>
                      <div style={{ flex: 1 }}>
                        <div style={styles.kitNom}>{kit.nom}</div>
                        <div style={styles.kitPrix}>
                          {fmtF(parseInt(kit.prix_kit))}
                        </div>
                      </div>
                      {!kit.actif && (
                        <span style={{
                          padding: '3px 8px', borderRadius: 12, fontSize: 11,
                          background: '#F1F5F9', color: '#64748B'
                        }}>Inactif</span>
                      )}
                    </div>

                    {kit.description && (
                      <p style={styles.kitDesc}>{kit.description}</p>
                    )}

                    <div style={styles.kitProduits}>
                      <div style={{ color: '#64748B', fontSize: 11, marginBottom: 6 }}>
                        <LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Composition ({(kit.produits || []).length} produit(s))
                      </div>
                      {(kit.produits || []).map((p, j) => (
                        <div key={j} style={styles.kitProduitRow}>
                          <span style={{ fontSize: 12 }}>{p.nom}</span>
                          <span style={{
                            background: '#EFF6FF', color: '#2563EB',
                            padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 700
                          }}>
                            x{p.qte_kit || 1}
                          </span>
                        </div>
                      ))}
                    </div>

                   <div style={styles.kitActions}>
                      <button onClick={() => handleModifier(kit)} style={styles.btnModifier}>
                        <LuPencil aria-hidden style={{ verticalAlign: '-0.125em' }} /> Modifier
                      </button>
                      <button
                        onClick={() => handleToggle(kit)}
                        style={kit.actif ? styles.btnDesactiver : styles.btnActiver} aria-label={kit.actif ? 'Désactiver' : 'Activer'} title={kit.actif ? 'Désactiver' : 'Activer'}>
                        {kit.actif ? <LuLock aria-hidden /> : <LuLockOpen aria-hidden />}
                      </button>
                      <button onClick={() => handleSupprimer(kit)} style={styles.btnSupprimer} aria-label="Supprimer" title="Supprimer">
                        <LuTrash2 aria-hidden style={{ verticalAlign: '-0.125em' }} />
                      </button>
                    </div>

                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* ── FORMULAIRE ── */}
        {vue === 'formulaire' && (
          <div style={styles.formCard}>
            <h2 style={styles.formTitre}>
              {kitSelectionne ? 'Modifier : ' + kitSelectionne.nom : 'Nouveau Kit'}
            </h2>

            <form onSubmit={handleSubmit}>

              {/* INFOS KIT */}
              <div style={styles.sectionForm}>
                <div style={styles.sectionFormTitre}><LuGift aria-hidden style={{ verticalAlign: '-0.125em' }} /> Informations du kit</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <div style={{ ...styles.champGroupe, gridColumn: '1 / -1' }}>
                    <label style={styles.label}>Nom du kit *</label>
                    <input type="text" value={form.nom}
                      onChange={(e) => setForm({ ...form, nom: e.target.value })}
                      style={styles.input} placeholder="Ex: Pack Barbecue, Menu Complet..."
                      required />
                  </div>
                  <div style={styles.champGroupe}>
                    <label style={styles.label}><LuWallet aria-hidden style={{ verticalAlign: '-0.125em' }} /> Prix du kit (FCFA) *</label>
                    <input type="number" min="0" value={form.prix_kit}
                      onChange={(e) => setForm({ ...form, prix_kit: e.target.value })}
                      style={styles.input} placeholder="Ex: 5000" required />
                    {prixCalcule > 0 && (
                      <div style={{ color: '#64748B', fontSize: 11, marginTop: 4 }}>
                        <LuLightbulb aria-hidden style={{ verticalAlign: '-0.125em' }} /> Coût des produits : {fmtF(prixCalcule)}
                        {form.prix_kit && (
                          <span style={{
                            marginLeft: 8, color: parseInt(form.prix_kit) < prixCalcule ? '#DC2626' : '#059669',
                            fontWeight: 700
                          }}>
                            {parseInt(form.prix_kit) < prixCalcule ? 'Sous le coût !' : 'Marge positive'}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div style={styles.champGroupe}>
                    <label style={styles.label}><LuFileText aria-hidden style={{ verticalAlign: '-0.125em' }} /> Description</label>
                    <input type="text" value={form.description}
                      onChange={(e) => setForm({ ...form, description: e.target.value })}
                      style={styles.input} placeholder="Description optionnelle..." />
                  </div>
                </div>
              </div>

              {/* COMPOSITION */}
              <div style={styles.sectionForm}>
                <div style={styles.sectionFormTitre}><LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Composition du kit</div>

                {/* AJOUTER PRODUIT */}
                <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'flex-end' }}>
                  <div style={{ flex: 2 }}>
                    <label style={styles.label}>Produit</label>
                    <select value={produitAjoute}
                      onChange={(e) => setProduitAjoute(e.target.value)}
                      style={styles.select}>
                      <option value="">Sélectionner un produit...</option>
                      {produits.map(p => (
                        <option key={p.id} value={p.id}>
                          {p.nom} — {fmtF(p.prix)}/{p.unite}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={styles.label}>Quantité</label>
                    <input type="number" min="1" value={qteAjoutee}
                      onChange={(e) => setQteAjoutee(e.target.value)}
                      style={styles.input} />
                  </div>
                  <button type="button" onClick={ajouterComposant}
                    style={styles.btnAjouter}>
                    <LuPlus aria-hidden style={{ verticalAlign: '-0.125em' }} /> Ajouter
                  </button>
                </div>

                {/* LISTE COMPOSANTS */}
                {composants.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 20, color: '#64748B', background: '#F8FAFC', borderRadius: 10 }}>
                    <LuPackage aria-hidden style={{ verticalAlign: '-0.125em' }} /> Ajoutez des produits au kit
                  </div>
                ) : (
                  <div>
                    {composants.map((c, i) => (
                      <div key={i} style={styles.composantRow}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 700, fontSize: 14 }}>{c.nom}</div>
                          <div style={{ color: '#64748B', fontSize: 12 }}>
                            {fmtF(c.prix) + '/' + c.unite + ' × ' + c.quantite + ' = ' +
                             fmtF((parseInt(c.prix) * c.quantite))}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <input type="number" min="1" value={c.quantite}
                            onChange={(e) => setComposants(composants.map((comp, j) =>
                              j === i ? { ...comp, quantite: parseInt(e.target.value) || 1 } : comp
                            ))}
                            style={{ ...styles.input, width: 70, padding: '6px 10px' }} />
                          <button type="button" onClick={() => retirerComposant(c.produit_id)}
                            style={{ background: '#FEF2F2', color: '#DC2626', border: 'none', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 13 }}>
                            ✕
                          </button>
                        </div>
                      </div>
                    ))}
                    <div style={{
                      display: 'flex', justifyContent: 'space-between',
                      padding: '12px 16px', background: '#F0FFF4',
                      borderRadius: 10, marginTop: 10, fontWeight: 700
                    }}>
                      <span><LuWallet aria-hidden style={{ verticalAlign: '-0.125em' }} /> Coût total des produits</span>
                      <span style={{ color: '#059669', fontSize: 16 }}>
                        {fmtF(prixCalcule)}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div style={styles.formActions}>
                <button type="button" onClick={() => { setVue('liste'); resetForm(); }}
                  style={styles.btnAnnuler}>Annuler</button>
                <button type="submit" style={styles.btnSauvegarder}>
                  {kitSelectionne ? 'Sauvegarder' : 'Créer le kit'}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </AppLayout>
  );
}

const styles = {
  chargement: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: 24, color: '#475569' },
  contenu: { ...S.contenu, flex: 1 },
  messageBox: { ...S.messageBox, marginBottom: 16 },
  header: S.header,
  headerTitre: S.headerTitre,
  headerSousTitre: S.headerSousTitre,
  boutonAjouter: S.boutonAjouter,
  boutonRetour: S.boutonRetour,
  etabSelector: { ...S.etabSelector, marginBottom: 20 },
  etabSelectorTitre: { ...S.etabSelectorTitre, marginBottom: 10 },
  filtres: { ...S.filtres, marginBottom: 16 },
  rechercheInput: { ...S.rechercheInput },
  vide: S.vide,
  kitsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 },
  kitCard: { background: 'white', borderRadius: 16, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  kitHeader: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 },
  kitIcon: { width: 48, height: 48, borderRadius: 12, background: '#FFF7ED', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 },
  kitNom: { fontWeight: 700, fontSize: 16, color: '#0F172A' },
  kitPrix: { fontWeight: 700, fontSize: 18, color: '#EA580C' },
  kitDesc: { color: '#64748B', fontSize: 13, marginBottom: 12, fontStyle: 'italic' },
  kitProduits: { background: '#F8FAFC', borderRadius: 10, padding: 12, marginBottom: 12 },
  kitProduitRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid #EFEFEF' },
  kitActions: { display: 'flex', gap: 8 },
  btnModifier: { ...S.btnModifier, flex: 1 },
  btnDesactiver: { ...S.btnDesactiver, flex: 1 },
  btnActiver: { ...S.btnActiver, flex: 1 },
  formCard: S.formCard,
  formTitre: { ...S.formTitre, marginBottom: 24 },
  sectionForm: { ...S.sectionForm, marginBottom: 24 },
  sectionFormTitre: { ...S.sectionFormTitre, marginBottom: 16 },
  champGroupe: S.champGroupe,
  label: S.label,
  input: { ...S.input, width: '100%' },
  select: { ...S.select, width: '100%' },
  btnAjouter: { padding: '12px 20px', background: '#059669', color: 'white', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap' },
  composantRow: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'white', borderRadius: 10, marginBottom: 8, border: '1px solid #E2E8F0' },
  formActions: { ...S.formActions, marginTop: 8 },
  btnAnnuler: S.btnAnnuler,
  btnSauvegarder: S.btnSauvegarder,
  btnSupprimer: { padding: '8px 12px', background: '#FEF2F2', color: '#DC2626', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13 },
};